import React from 'react';
import Link from '../Link';
import stylesheet from './ListItem.module.scss';

export function ListItemContent(props) {
    const { className = '', href, onClick, children } = props,
        Tag = href ? Link : 'div';

    return (
        <Tag className={[stylesheet.content, className].join(' ')} href={href} onClick={onClick}>
            {children}
        </Tag>
    );
}
